
import { Component, Vue } from 'vue-property-decorator';
import { iSelectOptionsList } from '@/interface/cancel-detail';
import PopupInspection from './popup-inspection.vue';
import { getMachinesList, getMachinesOperation, getMachinesBats, getMachinesExport, getMchSelects } from '@/api/service-tool';
import { getArea, reloadData } from '@/api/deviceManaging';
import { eCommand } from '../../../interface/eCommand';
import { iDevice, iNetbar, iCommandOperate } from '../../../interface/result';
import { toast, downloadFlie } from '../../../utils/common';
import LogUtils from 'panda-log';
@Component({
  components: { PopupInspection },
})
export default class deviceInspection extends Vue {
  total: number = 0;
  loading: boolean = false;
  refreshLoading: boolean = false;
  visibleInspection: boolean = false;
  multipleSelection: any[] = [];
  tableData: any[] = [];
  selectSeat: iSelectOptionsList[] = [
    {
      label: '高配',
      value: 2,
    },
    {
      label: '标配',
      value: 1,
    },

    {
      label: '尊享',
      value: 4,
    },
  ];
  selectState: iSelectOptionsList[] = [
    {
      label: '离线',
      value: 1,
    },
    {
      label: '故障',
      value: 2,
    },
    {
      label: '维护',
      value: 3,
    },
  ];
  selectRegion = [];
  selectMch: any[] = [];
  rowObj = {};
  //唤醒操作
  await_behaviour: eCommand = eCommand.AWAKE;
  //重启操作
  restart_behaviour: eCommand = eCommand.RESTART;
  //关机操作
  close_behaviour: eCommand = eCommand.CLOSE;
  //维护操作
  repair_behaviour: eCommand = eCommand.REPAIR;
  //取消维护
  cancel_repair_behaviour: eCommand = eCommand.CANCEL_REPAIR;
  private deviceParams = {
    region_id: '',
    mch_id: '',
    config_id: '', // 机型配置ID:1标配 2高配
    mch: '',
    machine: '',
    state: '', // 设备状态：1离线 2故障 3维护
    export: false, // boolean 是否导出 默认false不导出
    page: 1,
    size: 100,
    order: '',
  };
  mark: string = ''; // 维护原因
  ids: any = [];
  mch_id: any = '';
  sortChange({ column, prop, order }: any) {
    if (order == 'ascending') {
      // 正序
      this.deviceParams.order = '+' + prop;
      if (prop == 'config_id') {
        this.deviceParams.order = '+config';
      }
      if (prop == 'staff') {
        this.deviceParams.order = '+mark';
      }
    }
    if (order == 'descending') {
      // 倒叙
      this.deviceParams.order = '-' + prop;
      if (prop == 'config_id') {
        this.deviceParams.order = '-config';
      }
      if (prop == 'staff') {
        this.deviceParams.order = '-mark';
      }
    }
    if (!order) {
      // 默认
      this.deviceParams.order = '';
    }
    this.getDeviceList();
  }
  handleSizeChange(size: number) {
    this.deviceParams.page = 1;
    this.deviceParams.size = size;
    this.getDeviceList();
    //
  }
  handleCurrentChange(page: number) {
    this.deviceParams.page = page;
    this.getDeviceList();
  }
  searchList() {
    this.deviceParams.page = 1;
    this.getDeviceList();
  }
  handleSelectionChange(val: any) {
    this.ids = [];
    this.multipleSelection = val;
    for (const item of this.multipleSelection) {
      this.ids.push(item.id);
    }
  }
  regionChange(val: any) {
    this.getMchList(val);
  }
  mchChange(val: any) {
    this.deviceParams.region_id = val.region_id;
  }
  selectlear() {
    this.getMchList();
  }
  async getMchList(id?: number) {
    try {
      const res = await getMchSelects({ region_id: id });
      if (res && res.code == 0) {
        this.mch_id = '';
        this.selectMch = res.data;
        if (res.data.length == 1) {
          this.mch_id = res.data[0];
        }
      }
    } catch (err) {
      console.log(err);
      //
    }
  }
  /**
  刷新数据
   */
  async refreshData() {
    try {
      this.refreshLoading = true;
      await reloadData();
      this.getDeviceList();
    } catch (error) {
      toast('刷新数据失败', 'warning');
    } finally {
      this.refreshLoading = false;
    }
  }

  async exportUrl() {
    this.loading = true;
    this.deviceParams.export = true;
    try {
      const res = await getMachinesExport(this.deviceParams);
      if (res && res.code == 0) {
        downloadFlie(res.data, '设备巡检.xlsx');
      }
      this.loading = false;
    } catch (err) {
      this.loading = false;
      //
    }
  }
  handleCommand(command: iSelectOptionsList) {
    if (this.multipleSelection && this.multipleSelection.length > 0) {
      // 维护
      if (command.value == eCommand.REPAIR) {
        this.$prompt('维护原因：', '确认执行此操作吗', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          inputPattern: /\S/,
          inputErrorMessage: '请输入维护原因', // inputValue
          beforeClose: async (action, instance, done) => {
            this.mark = instance.inputValue;
            if (action === 'confirm') {
              instance.confirmButtonLoading = true;
              instance.confirmButtonText = '执行中...';
              this.instruct(command);
              done();
              instance.confirmButtonLoading = false;
            } else if (action === 'cancel') {
              done();
            }
          },
        }).then(action => {});
        return;
      }
      this.$msgbox({
        title: '确认执行' + command.label + '操作吗',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        beforeClose: async (action, instance, done) => {
          if (action === 'confirm') {
            instance.confirmButtonLoading = true;
            instance.confirmButtonText = '执行中...';
            switch (command.value) {
              case eCommand.AWAKE:
              case eCommand.RESTART:
              case eCommand.CLOSE:
              case eCommand.REPAIR:
              case eCommand.CANCEL_REPAIR:
                this.instruct(command);
                break;
              case 7:
                this.getDirectBats();
                break;
            }
            done();
            instance.confirmButtonLoading = false;
          } else if (action === 'cancel') {
            done();
          }
        },
      }).then(action => {});
      return;
    }
    this.$message('请勾选需要' + command.label + '的设备');
  }
  /**
   * 操作设备的状态
   */
  async instruct(command: iSelectOptionsList) {
    this.loading = true;
    try {
      await getMachinesOperation({ ids: this.ids, op: command.value, mark: command.value == eCommand.REPAIR ? this.mark : '' });
      this.getDeviceList();
      toast('操作成功');
    } catch (error) {
      LogUtils.warn('error', error);
    } finally {
      this.loading = false;
    }
  }
  async getDirectBats() {
    try {
      const res = await getMachinesBats({ ids: this.ids.join(',') });
      if (res && res.code == 0) {
        downloadFlie(res.data, '直连文件.zip');
      }
    } catch (err) {
      //
    }
  }
  handleDetial(row: any) {
    this.rowObj = row;
    this.visibleInspection = true;
  }
  handleEdit() {
    this.getDeviceList();
    this.cancelEit();
  }
  cancelEit() {
    this.visibleInspection = false;
  }
  async getDeviceList() {
    this.loading = true;
    this.deviceParams.export = false;
    this.deviceParams.mch_id = this.mch_id.mch_id || '';
    try {
      const res = await getMachinesList(this.deviceParams);
      if (res && res.code == 0) {
        this.tableData = res.data.list;
        this.total = res.data.total;
      }
      this.loading = false;
    } catch (err) {
      this.loading = false;
    }
  }
  async getgetArea() {
    try {
      const res = await getArea();
      if (res) {
        this.selectRegion = res.data;
      }
    } catch (err) {
      //
    }
  }
  mounted() {
    this.getgetArea();
    this.getMchList();
    this.getDeviceList();
  }
}
